/**
 * Collection Product List
 * Handles sort dropdown URL navigation.
 * Tag filtering is handled natively by Shopify via URL paths.
 */
(function () {
  var section = document.querySelector('[data-section-type="collection-product-list"]');
  if (!section) return;

  /* ---- Sort ---- */
  var sortSelect = section.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }
})();
